import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalstorageService {

  constructor() {
  }

  get(key: string): any {
    const res = localStorage.getItem(key);
    if (res && res !== 'undefined') {
      return JSON.parse(res);
    } else {
      return undefined;
    }
  }

  set(key: string, data: any): void {
    localStorage.setItem(key, JSON.stringify(data));
  }

  remove(key: string): void {
    localStorage.removeItem(key);
  }
}
